import React,{useState,useEffect} from 'react';
import queryString from 'query-string';
import Logo from '../../components/common/Logo';
import {useNavigate} from 'react-router-dom';
import swal from 'sweetalert';
import {useLocation} from 'react-router-dom';
import {resetPassword} from '../../actions/ForgotpassActions';

const GeneratePassword = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [token,setToken]=useState({name:'token',value:'',error:'',isRequired:true})
    const [email,setEmail]=useState({name:'email',value:'',error:'',isRequired:true})
    const [password,setPassword]=useState({name:'password',value:'',error:'',isRequired:true})
    const [confirmPassword,setConfirmPassword]=useState({name:'confirmPassword',value:'',error:'',isRequired:true})

   
    useEffect(()=>{
        const qParams = queryString.parse(location.search);
        if(qParams!==null){
            setToken({...token,value:qParams.t})
            setEmail({...email,value:qParams.email})
        }
    },[])

    const handleConfirmPasswordChange=(e)=>{
        setConfirmPassword({...confirmPassword,value:e.target.value,error:''})  
    }
    const validation = () => {
        var passRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        let formIsValid = true
        

        // Passowrd
        if (!password.value) {
            formIsValid = false
            let msg = "Please enter your password"
            setPassword({...password,error:msg})
        }
        if(password.value.length <= 7){
            formIsValid = false
            let msg = "Password must contain at least 8 characters"
            setPassword({...password,error:msg})
        }
        // if(password.value && !(passRegex.test(password.value))){
        //     formIsValid = false
        //     let msg = "Alpha Numeric Field with Minimum 8 Charcter Length and Required atleast 1 Uppercase, 1 Lower case, 1 special character, 1 number and 1 alphabet"
        //     setPassword({...password,error:msg})
        // }
    
        // confirm pass
        if (!confirmPassword.value){
            formIsValid = false
            let msg = "Please confirm you password"
            setConfirmPassword({...confirmPassword,error:msg})
        }
        if (confirmPassword.value!==password.value){
            formIsValid = false
            let msg = "Password is not matching"
            setConfirmPassword({...confirmPassword,error:msg})
        }
        
        if(formIsValid){
            setPassword({...password,error:''})
            setConfirmPassword({...confirmPassword,error:''})

        }
    
        return formIsValid;
    
    }

    const onSubmit=(e)=>{ 
        e.preventDefault();
        if(validation()){
            const data={
                token:token.value,
                email:email.value,
                password:password.value
            }
            resetPassword(data).then(res => {
                if (res.status) {
                    swal('Password generated successfully','','success');
                    navigate('/login');
                }
                else{
                    let msg = res.message ? res.message : 'Something went wrong'
                    swal(msg, '', 'error')
                }
            })
            .catch(err => {
                console.log(err);
            })
        }
            
    }
  return (
   <>
        <section className="py-5 login-page">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                    <div className="text-center">
                    <Logo alt="Logo"/>
                    </div>
                    <div className="login-box">
                        <div className="page-head">
                            <h2>Generate Password</h2>
                        </div>
                        <form onSubmit={onSubmit}>
                            <div className="row">
                                <div className="col-lg-12 mb-3">
                                    <div className="form-floating">
                                    <input
                                        type="password"
                                        className="form-control"
                                        name="password"
                                        placeholder="Password"
                                        value={password.value}
                                        onChange={(e) => setPassword({...password,value:e.target.value, error:''})}
                                    />
                                        <label>Password</label> 
                                    </div>
                                    {password.error.length>0 &&<div className='invalidFeedback'>{password.error}</div>}

                                </div>
                                <div className="col-lg-12 mb-3">
                                    <div className="form-floating">
                                    <input
                                        type="password"
                                        className="form-control"
                                        name="password"
                                        placeholder="Password"
                                        value={confirmPassword.value}
                                        onChange={handleConfirmPasswordChange}
                                    />
                                    <label>New Password</label> 
                                    </div>
                                    {confirmPassword.error.length>0 &&<div className='invalidFeedback'>{confirmPassword.error}</div>}

                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3 text-start">
                                    <button type="submit" className="btn btn-primary btn-lg auth_btn">Submit</button>
                                </div>
                                

                            </div>
                            </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
   
   </>
  )
}

export default GeneratePassword
